import { BugFilled, LikeFilled } from '@ant-design/icons'
import { useChannels } from '@entities/channel'
import imageSlide from '@shared/assets/mobile/main_3_slide.png'
import useMobileView from '@shared/hooks/isMobile'
import { Breadcrumbs } from '@widgets/breadcrumbs'
import { Navbar } from '@widgets/navbar'
import { Sidebar } from '@widgets/sidebar'
import { Button, Divider, Flex, Image, Layout, Space, theme, Typography } from 'antd'
import { SafeArea } from 'antd-mobile'
import { Link, Outlet, useLocation } from 'react-router-dom'
import * as styles from './page-template.module.scss'

const { Title, Text } = Typography

const { Content, Footer } = Layout

export const PageTemplate = () => {
    const {
        token: { colorSuccess, colorError, colorBgLayout }
    } = theme.useToken()
    const isMobile = useMobileView()
    const location = useLocation()
    const isInterntResources = location.pathname.includes('internet-resources')
    const isStartPage = location.pathname === '/'

    const { channels } = useChannels()

    const emptyChannels = channels?.length === 0

    if (isMobile) {
        return (
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <SafeArea position="top" />
                <Layout style={{ flex: 1 }}>
                    <Divider style={{ margin: 0 }} />
                    {emptyChannels && !isStartPage && !isInterntResources ? (
                        <div style={{ height: '100%' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', height: '80%' }}>
                                <Link
                                    to={'https://t.me/telegaplanbot/?startapp&addToHomeScreen'}
                                    style={{
                                        width: 358,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    <Title level={3} style={{ marginBottom: 24, marginTop: 28, textAlign: 'center' }}>
                                        Для использования раздела добавьте интернет-ресурс
                                    </Title>
                                    <Flex
                                        style={{
                                            padding: '10px 10p 10px 0',
                                            backgroundColor: colorBgLayout,
                                            borderRadius: 8,
                                            height: '100px',
                                            marginBottom: 10,
                                            position: 'relative'
                                        }}
                                        align="center"
                                    >
                                        <div style={{ width: 147 }}>
                                            <Image src={imageSlide} alt="" preview={false} />
                                        </div>
                                        <div style={{ position: 'absolute', left: 90 }}>
                                            <Title style={{ marginTop: 0, marginBottom: 0 }} level={5}>
                                                Нужен быстрый доступ к Telegaplan?
                                            </Title>
                                            <Text>Закрепи на главном экране</Text>
                                        </div>
                                    </Flex>
                                </Link>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    width: '100%',
                                    justifyContent: 'center',
                                    marginTop: 20,
                                    marginBottom: 70
                                }}
                            >
                                <Link to={'/internet-resources?modal=true'}>
                                    <Button type="primary" style={{ fontSize: 17, height: 40, borderRadius: 10 }}>
                                        Подключить канал
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    ) : (
                        <Outlet />
                    )}
                </Layout>

                <SafeArea position="bottom" />
            </div>
        )
    }

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sidebar />
            <Layout>
                <Navbar />
                <Content style={{ padding: '0 16px' }}>
                    <Breadcrumbs />
                    <Outlet />
                </Content>
                <Footer style={{ textAlign: 'center' }}>
                    Copyright 2024-{new Date().getFullYear()}. Все права защищены
                    <Space className={styles.contact}>
                        <Button
                            type="link"
                            href="https://t.me/arkimp"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ backgroundColor: colorSuccess, color: '#fff' }}
                        >
                            <BugFilled />
                            Нашел баг
                        </Button>
                        <Button
                            type="link"
                            href="https://t.me/arkimp"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ backgroundColor: colorError, color: '#fff' }}
                        >
                            <LikeFilled />У меня идея
                        </Button>
                    </Space>
                </Footer>
            </Layout>
        </Layout>
    )
}
